import { render } from "./ClassesView.vue?vue&type=template&id=de9475fa"
import script from "./ClassesView.vue?vue&type=script&lang=js"
export * from "./ClassesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__